import React, { useState } from 'react';
import Select from "react-select";
import { FaEdit, FaTrash } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Activity = ({ setActivityList, activityList }) => {

    const [formData, setFormData] = useState({
        type: null,
        purpose: null,
        status: null,
        followup: null,
        visitDate: null,
        remarks: '',
    });

    const [editIndex, setEditIndex] = useState(null);

    const contactTypes = [
        { label: "Office", value: "Office" },
        { label: "Office Phone", value: "Office Phone" },
        { label: "Office Fax", value: "Office Fax" },
        { label: "Res Phone", value: "Res Phone" },
        { label: "Res Fax", value: "Res Fax" },
        { label: "Mobile No", value: "Mobile No" },
        { label: "Rep Office Phone", value: "Rep Office Phone" },
        { label: "Rep Res Phone", value: "Rep Res Phone" },
        { label: "Rep Fax", value: "Rep Fax" },
        { label: "Rep Mobile", value: "Rep Mobile" },
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSelectChange = (selected) => {
        setFormData(prev => ({ ...prev, type: selected }));
    };
    const handlepurposeChange = (selected) => {
        setFormData(prev => ({ ...prev, purpose: selected }));
    };
    const handleStatusChange = (selected) => {
        setFormData(prev => ({ ...prev, status: selected }));
    };
    const handleAddOrUpdate = () => {

        if (editIndex !== null) {
            const updatedList = activityList.map((item, i) =>
                i === editIndex ? { ...formData } : item
            );
            setActivityList(updatedList);
            setEditIndex(null);
        } else {
            setActivityList(prev => [...prev, { ...formData }]);
        }

        setFormData({
            type: null,
            purpose: null,
            status: null,
            followup: null,
            visitDate: null,
            remarks: '',
        });
    };
    const handleEdit = (index) => {
        setFormData({ ...activityList[index] });
        setEditIndex(index);
    };
    const handleDelete = (index) => {
        const filtered = activityList.filter((_, i) => i !== index);
        setActivityList(filtered);
    };
    const handleDateChange = ({ name, value }) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    };
    const formatDate = (date) =>
        date ? new Date(date).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        }) : "";

    return (
        <div className="cost-center-section my-3">
            <div className="border-box2 p-3" style={{ borderRadius: '8px' }}>

                <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(370px, 1fr))', gap: '20px' }}>

                    {/* Contact Type */}
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Type</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            options={contactTypes}
                            value={formData.type}
                            onChange={handleSelectChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Purpose</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            options={contactTypes}
                            value={formData.purpose}
                            onChange={handlepurposeChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Status</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            options={contactTypes}
                            value={formData.status}
                            onChange={handleStatusChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Followup</label>
                        <DatePicker
                            selected={formData.followup}
                            onChange={(date) => handleDateChange({ name: 'followup', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Visit Date</label>
                        <DatePicker
                            selected={formData.visitDate}
                            onChange={(date) => handleDateChange({ name: 'visitDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Action Taken</label>
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="remarks"
                            value={formData.remarks}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>

                {/* ADD / UPDATE BUTTON */}
                <div className='my-4'>
                    <div
                        className='mainbtnSecondary flex-end gap-2 col-2'
                        style={{ cursor: "pointer" }}
                        onClick={handleAddOrUpdate}
                    >
                        <FaPlus color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>
                            {editIndex !== null ? "Update Activity" : "Add Activity"}
                        </div>
                    </div>
                </div>

                {/* TABLE */}
                <div className='table-container' style={{ overflowX: 'auto', height: "400px" }}>
                    <table className='table table-bordered gridshad'>
                        <thead className='dynoTable'>
                            <tr>
                                <th>Action</th>
                                <th>Type</th>
                                <th>Purpose</th>
                                <th>Followup</th>
                                <th>Status</th>
                                <th>Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            {activityList.map((data, index) => (
                                <tr key={index}>
                                    <td className="text-center d-flex gap-3">
                                        <div className='center mt-2'>
                                            <FaEdit
                                                size={20}
                                                style={{ cursor: "pointer", color: "black" }}
                                                onClick={() => handleEdit(index)}
                                            />
                                        </div>
                                        <div className='center mt-2'>
                                            <FaTrash
                                                size={20}
                                                style={{ cursor: "pointer", color: "red" }}
                                                onClick={() => handleDelete(index)}
                                            />
                                        </div>
                                    </td>
                                    <td>{data.type?.label}</td>
                                    <td>{data.purpose?.label}</td>
                                    <td>{formatDate(data.followup)}</td>
                                    <td>{data.status?.label}</td>
                                    <td>{data.remarks}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    );
};

export default Activity;
